import api from './api';

/**
 * Autorizações temporárias de operações sensíveis (reeditar/excluir registro
 * clínico já finalizado).
 *
 * Antes a senha do usuário era validada e guardada em `sessionStorage` para ser
 * reenviada depois — persistia no navegador e vazava em qualquer XSS. Agora o
 * servidor devolve um token de uso único e curta duração, que fica APENAS aqui
 * em memória do módulo: recarregar a página descarta e a tela pede a senha de
 * novo.
 *
 * Chave = identificador da operação, no mesmo formato aceito pelo backend:
 *   sessao:<id>:editar | sessao:<id>:evolucao | evolucao:<id>:excluir
 */
const tokens = new Map();

export const guardarAutorizacao = (operacao, token) => {
    if (operacao && token) tokens.set(operacao, token);
};

export const temAutorizacao = (operacao) => tokens.has(operacao);

/** Lê e descarta o token — o backend também aceita uma única utilização. */
export const consumirAutorizacao = (operacao) => {
    const token = tokens.get(operacao);
    tokens.delete(operacao);
    return token || null;
};

export const descartarAutorizacoes = () => tokens.clear();

/** Pede autorização ao servidor conferindo a senha do próprio usuário. */
export const solicitarAutorizacao = async (operacao, senha) => {
    const { data } = await api.post('/auth/autorizacao', { senha, operacao });
    guardarAutorizacao(operacao, data?.autorizacao);
    return data?.autorizacao || null;
};

/**
 * Variante usada pela lista de sessões: valida a senha no contexto da sessão e
 * já recebe o token da operação pedida ('editar' ou 'evolucao').
 */
export const solicitarAutorizacaoSessao = async (idSessao, operacao, senha) => {
    const { data } = await api.post(`/sessoes/${idSessao}/validar-senha`, { senha, operacao });
    const chave = `sessao:${idSessao}:${operacao}`;
    guardarAutorizacao(chave, data?.autorizacao);
    return data?.autorizacao || null;
};
